import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Icon, Divider } from 'semantic-ui-react';
import { assetUrl } from '../../../../utils/graphqlClient';

import './modify-entry.scss';

class ModifyEntry extends React.Component {
  constructor(props) {
    super(props);
    const {
      id,
      name,
      place,
      customClass,
      src,
      thumb,
      isPublished,
      gps,
      description,
      labelId,
      isStarred,
      make,
      model,
      exposure,
      fnumber,
      iso,
      focalDistance
    } = this.props.picture;

    this.state = {
      id,
      name,
      place,
      customClass,
      src,
      thumb,
      isPublished: typeof isPublished === 'boolean' ? isPublished : true,
      lat: gps?.coordinates?.[1] || '',
      lng: gps?.coordinates?.[0] || '',
      description,
      labelId,
      isStarred,
      make,
      model,
      exposure,
      fnumber,
      iso,
      focalDistance,
      file: null,
    };
  }

  changeInput = (evt) => {
    this.setState({
      [evt.target.name]: evt.target.value,
    });
  }

  handleChange = (e, {value, name}) => {    
    this.setState({
      [name]: value,
    });
  }

  handleToggle = (_event, { checked, name }) => {
    this.setState({
      [name]: checked,
    });
  }

  handleUpload = (evt) => {
    const file = evt.target.files?.[0] || null;
    this.setState({
      file,
      src: file ? file.name : this.state.src,
      thumb: file ? file.name : this.state.thumb,
    });
  }

  onSubmitForm = (evt) => {
    evt.preventDefault();
    this.props.onSubmit(this.state);
  };

  
  render() {
    const { labels } = this.props;
    const options = [
      {key: 1, text: 'thumb-paysage', value: 'thumb-paysage' },
      {key: 2, text: 'thumb-portrait', value: 'thumb-portrait'}
    ];
    const options1 = labels
      .filter((label) => String(label.name).toLowerCase() !== 'all')
      .map((label) => (
        { key: Number(label.id), text: String(label.name), value: Number(label.id) }
      ));

    const uploadLabelValue = this.state.file === null ? 'Replace source file' : this.state.file.name;
      
    return (
      <>
        <div className="modify-entry">
          <Form size="tiny" className="add-entry-form" onSubmit={this.onSubmitForm}>
            <Form.Field>
              <label className="upload-cstm-btn" htmlFor="picture-source-replace">
                {uploadLabelValue}
              </label>
              <input
                id="picture-source-replace"
                name="replaceUpload"
                type="file"
                onChange={this.handleUpload}
              />
            </Form.Field>

            <Form.Field>
              {this.state.thumb ? (
                <img
                  src={assetUrl(`uploads/${this.state.thumb}`)}
                  alt={this.state.name || 'Current thumbnail'}
                  style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6 }}
                />
              ) : null}
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Input
                fluid
                placeholder="Name"
                value={this.state.name}
                name="name"
                onChange={this.changeInput}
                type="text"
              />
              <Form.Input
                fluid
                placeholder="Place"
                value={this.state.place}
                name="place"
                onChange={this.changeInput}
                type="text"
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Input
                fluid
                placeholder="Src"
                value={this.state.src}
                name="src"
                onChange={this.changeInput}
                type="text"
              />
              <Form.Input
                fluid
                placeholder="Thumb"
                value={this.state.thumb}
                name="thumb"
                onChange={this.changeInput}
                type="text"
              />
            </Form.Group>

            <Divider horizontal>
              <Icon name='map' />
              GPS Info
            </Divider>

            <Form.Group widths="equal">
              <Form.Input
                fluid
                placeholder="Latitude"
                value={this.state.lat}
                name="lat"
                onChange={this.changeInput}
                type="text"
              />
              <Form.Input
                fluid
                placeholder="Longitude"
                value={this.state.lng}
                name="lng"
                onChange={this.changeInput}
                type="text"
              />
            </Form.Group>

            <Divider horizontal>
              <Icon name='sort' />
              Sorting
            </Divider>

            <Form.Group widths="equal">
              <Form.Select
                fluid
                options={options}
                name="customClass"
                value={this.state.customClass}                
                onChange={this.handleChange}
              />
              <Form.Select
                fluid
                options={options1}
                name="labelId"
                value={this.state.labelId ?? ''}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Checkbox
                label="Published"
                name="isPublished"
                checked={this.state.isPublished}
                onChange={this.handleToggle}
              />
            </Form.Group>

            <Divider horizontal>
              <Icon name='photo' />
              Technical Info
            </Divider>

            <Form.Group widths="equal">
              <Form.Input
                fluid
                placeholder="Camera make"
                value={this.state.make}
                name="make"
                onChange={this.changeInput}
                type="text"
              />
              <Form.Input
                fluid
                placeholder="Camera model"
                value={this.state.model}
                name="model"
                onChange={this.changeInput}
                type="text"
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Input
                fluid
                placeholder="Exposure time"
                value={this.state.exposure}
                name="exposure"
                onChange={this.changeInput}
                type="text"
              />
              <Form.Input
                fluid
                placeholder="Aperture (f-number)"
                value={this.state.fnumber}
                name="fnumber"
                onChange={this.changeInput}
                type="text"
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Input
                fluid
                placeholder="ISO"
                value={this.state.iso}
                name="iso"
                onChange={this.changeInput}
                type="text"
              />
              <Form.Input
                fluid
                placeholder="Focal length"
                value={this.state.focalDistance}
                name="focalDistance"
                onChange={this.changeInput}
                type="text"
              />
            </Form.Group>

            <Divider horizontal>
              <Icon name='text cursor' />
              Caption
            </Divider>

            <Form.TextArea
              placeholder="Description"
              value={this.state.description}
              name="description"
              onChange={this.changeInput}
              type="text"
            />

            <Button className="cstm-btn" type="submit">Submit</Button>
          </Form>
        </div>
      </>
    );
  }
}

ModifyEntry.propTypes = {
  picture: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    place: PropTypes.string,
    customClass: PropTypes.string,
    src: PropTypes.string,
    thumb: PropTypes.string,
    gps: PropTypes.shape({
      coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
    description: PropTypes.string,
    labelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isPublished: PropTypes.bool,
    isStarred: PropTypes.bool,
    make: PropTypes.string,
    model: PropTypes.string,
    exposure: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fnumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    iso: PropTypes.string,
    focalDistance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModifyEntry;
